import Vue from 'vue';
import Main from './views/Main'
import router from './router'
import ElementUI from 'element-ui'; // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css'; // 2.2引入样式
Vue.use(ElementUI); 
import './assets/iconfont/iconfont.css'
//css
import './assets/css/common.css'
//js
import { goback } from './assets/js/common';
//monent
import moment from 'moment';
Vue.prototype.$moment = moment;
//linq
import Enumerable from 'linq';
Vue.prototype.$linq = Enumerable;
//request
import {get, post, download } from "./assets/js/request";
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$goback = goback;
Vue.prototype.$download = download;
// 裁剪
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
// 主题
import { addColor } from './assets/js/addColor';
addColor(true)

Vue.config.productionTip = false;
new Vue({
    router,
    render: h => h(Main)
}).$mount("#layout");